import { Ability } from '@precon-tools-suite-by-shared/shared-auth-js-ability-checks';
import { ensureAuthenticated } from '@precon-tools-suite-by-shared/vue-msal';
import type { Router } from 'vue-router';
import type { RouteLocationRaw, RouteLocationNormalized } from 'vue-router';
import { useAuthorizationStore } from '../stores/authorization';

declare module 'vue-router' {
    interface RouteMeta {
        requiresAuth?: boolean;
        policy?: Ability<[to: RouteLocationNormalized]>;
    }
}

export type RouterGuardOptions = {
    unauthenticatedRoute?: RouteLocationRaw;
    authorizedRoute?: RouteLocationRaw;
};

export function setupRouterGuards(
    router: Router,
    options: RouterGuardOptions = {}
) {
    router.beforeEach(async (to: RouteLocationNormalized) => {
        if (to.meta.requiresAuth) {
            const account = await ensureAuthenticated({
                redirectStartPage: router.options.history.base + to.fullPath,
            });

            if (!account) {
                return options.unauthenticatedRoute ?? false;
            }
        }

        if (to.meta.policy) {
            const allowed = useAuthorizationStore().authContext.check(
                to.meta.policy,
                to
            );

            if (!allowed) {
                return options.authorizedRoute ?? false;
            }
        }

        return true;
    });
}
